import { useContext } from 'react';
import WalletAssetsContext from '../contexts/WalletAssetsContext';

const useWalletAssetsContext = () => useContext(WalletAssetsContext);

export default useWalletAssetsContext;
